module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_gc-e15cdb1722591bf0f19814870af645ee.gif";